/**
 * Inject a CSS variable named `--scrollbar-width` which contains the browser scrollbar width value (in pixel)
 */
export default function scrollbarWidthDetection() {
    if (document.documentElement.scrollHeight <= window.innerHeight) {
        document.querySelector('html').style.setProperty('--scrollbar-width', `0px`);
        return;
    }

    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    document.body.append(outer);

    const widthNoScroll = outer.offsetWidth;

    // Force scrollbars
    outer.style.overflow = 'scroll';

    // Add innerdiv
    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.append(inner);

    const widthWithScroll = inner.offsetWidth;

    // Remove divs
    outer.remove();

    document.querySelector('html').style.setProperty('--scrollbar-width', `${widthNoScroll - widthWithScroll}px`);
};